@import "src/style/lib";
.messageBanner {
  position: fixed;
  z-index: 1500;
  top: 0;
  left: 0;
  right: 0;

  @media print {
    display: none;
  }

  .bannerMessage {
    position: relative;
    @media (max-width: 74.98rem) {
      font-size: 0.9em;
    }
    @media (max-width: 35.98rem) {
      font-size: 0.85em;
    }
    @media (max-width: 24.98rem) {
      font-size: 0.77em;
    }
    overflow: hidden;
    background: $bjelin-dark-grey;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.5em;

    &.success {
      background: $bjelin-green;
    }
    &.warn {
      background: $highlight-background-color;
    }
    &.error {
      background: $bjelin-red;
    }

    @include media-breakpoint-down("sm") {
      flex-direction: column;
    }

    .msg-content {
      display: flex;
      align-items: center;
      .msg-icon {
        position: relative;
        top: 0;
        left: 0;
        margin: 0.5em;
        line-height: 0;
        flex: 0 0 auto;
      }
      .msg-text {
        padding: 0.5em;
        line-height: 1.25em;
        text-align: left;
        overflow: hidden;
      }
    }

    .msg-buttons {
      padding: 0.5em;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1em;
      flex: 0 0 auto;

      .btn-link {
        --bs-btn-color: white;
        --bs-btn-hover-color: var(--bs-bjelin-orange);
      }
      .btn-outline-light {
        --bs-btn-color: white;
        --bs-btn-border-color: white;
        --bs-btn-hover-color: var(--bs-bjelin-orange);
        --bs-btn-hover-border-color: var(--bs-bjelin-orange);
      }

      .button-icon {
        vertical-align: middle;
        &.before {
          margin-right: 0.5em;
        }
        &.after {
          margin-left: 0.5em;
        }
      }
    }
  }
}
